"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leasingInputFragment = exports.leasingInputFields = void 0;
exports.leasingInputFields = `
  agreementCode
  downPayment
  durationMonths
  ignoreCampaigns
  includeFeesInFinancedAmount
  investedAmount
  isObjectDirectlyImported
  isObjectNew
  manualAdministrationFee
  manualNominalInterest
  mileage
  objectGroupCode
  objectMake
  objectModel
  registrationFee
  residualValue
  serviceAgreementPerYearFee
  tireHotelPerYearFee
`;
exports.leasingInputFragment = `
  fragment leasing on LeasingInputDefaults {
    ${exports.leasingInputFields}
  }
`;
//# sourceMappingURL=leasing.js.map